import React from 'react';
import { CnButton } from '../cn-button';
import { CnIcon } from '../cn-icon';
function SliderArrow(props) {
    const { className, loop, current = -1, total, swipeNext, swipePrev } = props;
    return (React.createElement("div", { className: `${className || ''} cn-ui-m-slider-arrow` },
        React.createElement(CnButton, { className: "arrow-icon arrow-left", disabled: loop ? false : current === 0, onClick: () => swipePrev() },
            React.createElement(CnIcon, { type: "icon-arrow-left", size: "xxl" })),
        React.createElement(CnButton, { className: "arrow-icon arrow-right", disabled: loop ? false : current + 1 === total, onClick: () => swipeNext() },
            React.createElement(CnIcon, { type: "icon-arrow-right", size: "xxl" }))));
}
export default SliderArrow;
